<template>
  <div>
    <b-row>
      <!-- Not Started Column -->
      <b-col md="3">
        <b-card class="border-top-gray">
          <b-card-header class="px-0 pt-0">Not Started</b-card-header>
          <b-card-body class="p-0 drag-container">
            <draggable v-model="notStarted" group="cards" @change="onChange">
              <b-card
  v-for="(task, index) in notStarted"
  :key="task.id"
  :style="{ border: '2px solid rgb(159, 197, 76)' }"
>
                <b-card-header class="px-0 pt-0">
                  <b-badge :variant="getPriorityVariant(task.priority)">
                    {{ task.priority }} Priority
                  </b-badge>
                </b-card-header>
                <b-card-body class="p-0">
                  <b-card-title>{{ task.title }}</b-card-title>
                  <b-card-text>{{ task.description }}</b-card-text>
                  <b-card-text>Sub Tasks ({{ task.totalSubTasks }})</b-card-text>
                </b-card-body>
                <b-card-footer>

                </b-card-footer>
              </b-card>
            </draggable>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- In Progress Column -->
      <b-col md="3">
        <b-card class="border-top-info">
          <b-card-header class="px-0 pt-0">In Progress</b-card-header>
          <b-card-body class="p-0 drag-container">
            <draggable v-model="inProgress" group="cards" @change="onChange">
              <b-card
                v-for="(task, index) in inProgress"
                :key="task.id"
                 :style="{ border: '2px solid rgb(159, 197, 76)' }"
              >
                <b-card-header class="px-0 pt-0">
                  <b-badge :variant="getPriorityVariant(task.priority)">
                    {{ task.priority }} Priority
                  </b-badge>
                </b-card-header>
                <b-card-body class="p-0">
                  <b-card-title>{{ task.title }}</b-card-title>
                  <b-card-text>{{ task.description }}</b-card-text>
                  <b-card-text>Sub Tasks ({{ task.totalSubTasks }})</b-card-text>
                </b-card-body>
              </b-card>
            </draggable>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- On Hold Column -->
      <b-col md="3">
        <b-card class="border-top-warning">
          <b-card-header class="px-0 pt-0">On Hold</b-card-header>
          <draggable v-model="onHold" group="cards" @change="onChange">
            <template>
              <b-card
                v-for="(task, index) in onHold"
                :key="task.id"
                 :style="{ border: '2px solid rgb(159, 197, 76)' }"
              >
                <b-card-header class="px-0 pt-0">
                  <b-badge :variant="getPriorityVariant(task.priority)">
                    {{ task.priority }} Priority
                  </b-badge>
                </b-card-header>
                <b-card-body class="p-0">
                  <b-card-title>{{ task.title }}</b-card-title>
                  <b-card-text>{{ task.description }}</b-card-text>
                  <b-card-text>Sub Tasks ({{ task.totalSubTasks }})</b-card-text>
                </b-card-body>
              </b-card>
            </template>
          </draggable>
        </b-card>
      </b-col>

      <!-- Completed Column -->
      <b-col md="3">
        <b-card class="border-top-success">
          <b-card-header class="px-0 pt-0">Completed</b-card-header>
          <draggable v-model="completed" group="cards" @change="onChange">
            <template>
              <b-card
                v-for="(task, index) in completed"
                :key="task.id"
               :style="{ border: '2px solid rgb(159, 197, 76)' }"
              >
                <b-card-header class="px-0 pt-0">
                  <b-badge :variant="getPriorityVariant(task.priority)">
                    {{ task.priority }} Priority
                  </b-badge>
                </b-card-header>
                <b-card-body class="p-0">
                  <b-card-title>{{ task.title }}</b-card-title>
                  <b-card-text>{{ task.description }}</b-card-text>
                  <b-card-text>Sub Tasks ({{ task.totalSubTasks }})</b-card-text>
                </b-card-body>
              </b-card>
            </template>
          </draggable>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BBadge,
} from "bootstrap-vue";
import { mapActions } from "vuex";

export default {
  name: "kanban-task",
  components: {
    draggable,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
  },
  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      notStarted: [],
      inProgress: [],
      onHold: [],
      completed: [],
    };
  },
  watch: {
    tasks: {
      handler(newTasks) {
        this.initializeLists(newTasks);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("projectModule", ["updateProjectTaskStatusAction"]),

    initializeLists(tasks) {
      this.notStarted = tasks.filter((task) => task.status === "NOTSTARTED");
      this.inProgress = tasks.filter((task) => task.status === "INPROGRESS");
      this.onHold = tasks.filter((task) => task.status === "ONHOLD");
      this.completed = tasks.filter((task) => task.status === "COMPLETED");
    },

    async onChange(event) {
      const newStatusMap = {
        notStarted: "NOTSTARTED",
        inProgress: "INPROGRESS",
        onHold: "ONHOLD",
        completed: "COMPLETED",
      };

      try {
        const updatePromises = [];
        for (const [listName, status] of Object.entries(newStatusMap)) {
          for (const task of this[listName]) {
            if (task.status !== status) {
              task.status = status;
              updatePromises.push(
                this.updateProjectTaskStatusAction({
                  projectId: task.projectId,
                  taskId: task.id,
                  status: task.status,
                })
              );
            }
          }
        }

        await Promise.all(updatePromises)
        this.$emit("update:tasks", this.tasks);
      } catch (error) {
        this.error("Failed to update task status");
        console.error("Failed to update task status:", error);
      } finally {
        loader.close();
      }
    },
    success(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(message) {
      this.$swal({
        title: "Error!",
        text: message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
    },

    getPriorityVariant(priority) {
      switch (priority) {
        case "HIGH":
          return "danger";
        case "MEDIUM":
          return "warning";
        case "LOW":
          return "secondary";
        default:
          return "secondary";
      }
    },
  },
};
</script>

</script>

<style scoped>



</style>
